var map = {
	"./de/Abb15-Pflanzen-Bodenwasserspeicher-Kuehlung-Muc-Wzbg.png": 36091,
	"./en/Abb15-Pflanzen-Bodenwasserspeicher-Kuehlung-Muc-Wzbg.png": 49665
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 98626;